exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#mulesoft-source-info-tooltip {\n    background: #fff;\n\tborder: 1px solid #E5E7E7;\n\tdisplay: none;\n\tpadding: 10px;\n\tpadding-bottom: 0px;\n\tposition: absolute;\n}\n#mulesoft-source-info-tooltip .slds-button {\n\tmargin-left: calc(50% - 80px);\n\tmargin-top: 12px;\n}\n\n#mulesoft-source-info-tooltip h4 {\n\tfont-weight: 700;\n}\n#mulesoft-source-info-tooltip h4, #mulesoft-source-info-tooltip p {\n    color: #706E6B;\n    margin-bottom: 10px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/DataSources/dash-card.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/DataSources/dash-card.css
// module chunks = 0